import "./Team.scss"
import Card from "../../components/Card/Card";
import {useState, useEffect} from "react";

const Team = ({id}) => {
    const [studentsData, setStudentsData] = useState([]);
    const [mentorsData, setMentorsData] = useState([]);
    useEffect(() => {
        fetch("./team.csv")
            .then((res) => res.text())
            .then((text) => {
                const txt = text.split("\n")
                let students = [];
                let mentors = [];

                for (let i = 1; i < txt.length; i++) {
                    const person = txt[i].split(",");
                    if (person.includes("Студент(-ка)")){
                        students.push({
                            name: person[1],
                            pic: person[2],
                            team: person[5].replace("\r", "")
                        })
                    } else if (person.includes("Ментор(-ка)")){
                        mentors.push({
                            name: person[1],
                            pic: person[2],
                            workplace: person[6],
                            job: person[7].replace("\r", "")
                        })
                    }
                }
                setStudentsData(students);
                setMentorsData(mentors);
            });
    }, []);

    return (
        <section className="Team" id={id}>
            <div className="Team-description">
                <h2>Team</h2>
                <p className="Team-description-p">talented group of passionate researchers, engineers and students</p>
            </div>
            <div className="Team-principles-collection">
                <h3>Principles</h3>
                <div className="Team-principles-collection-cards">
                    {
                        mentorsData && mentorsData.map((person, i) => (
                            <Card person={person} key={i}/>
                        ))
                    }
                </div>
            </div>
            <div className="Team-students-collection">
                <h3>students</h3>
                <div className="Team-students-collection-cards">
                    {
                        studentsData && studentsData.map((person, i) => (
                            <Card person={person} key={i}/>
                        ))
                    }
                </div>
            </div>
        </section>
    );
}
export default Team;